import { render, staticRenderFns } from "./ArticleListView.vue?vue&type=template&id=0c04ebd9&scoped=true"
import script from "./ArticleListView.vue?vue&type=script&lang=js"
export * from "./ArticleListView.vue?vue&type=script&lang=js"
import style0 from "./ArticleListView.vue?vue&type=style&index=0&id=0c04ebd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c04ebd9",
  null
  
)

export default component.exports